import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import Modal from 'react-bootstrap/Modal';
// import SecondaryButton from "../../components/UI/Buttons/SecondaryButton";


import classes from './SessionTimeoutModal.module.scss';



/**
 */
class SessionTimeoutModalModal extends Component {


    closeModal = () => {

        this.props.hide();
    };


    render() {

        return (

            <Modal
                className={classes.modal}
                show={this.props.show}
                onHide={this.closeModal}
                keyboard={false}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>

                <Modal.Body>

                    <img className={classes.closeBtn}
                         onClick={this.closeModal}
                         src={require("../../assets/images/icons/ico-close.svg").default}
                         alt=""/>

                    <div className={"text-center"} style={{marginTop:"20px",marginBottom:"20px"}}>
                        Due to inactivity for 120 minutes you have been logged out of this site.
                    </div>

                    <div className={"text-center"}>
                        {/*<SecondaryButton onClick={this.closeModal}>Close</SecondaryButton>*/}
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}


export default withRouter(SessionTimeoutModalModal);
